/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import {Button, ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import i18n from "i18next";
import HearText from "./HearText";
import HearFacebookGeneric from "./HearFacebookGeneric";
import HearFacebookButtons from "./HearFacebookButtons";
import HearImage from "./HearImage";
import getValueFromArray from "../../utils/getValueFromArray";

class HearReply extends Component {


    static FACEBOOK_GENERIC = "facebook_generic";
    static FACEBOOK_BUTTON = "facebook_button";
    static TEXT = "text";
    static IMAGE = "image";

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.select = this.select.bind(this);

        const {replyData, repliesData} = this.props;

        // let hearReplyData = replyData === null ? undefined : replyData;
        let hearReplyData = repliesData === null ? undefined : repliesData[this.props.replyIndex];
        let type = getValueFromArray(hearReplyData, 'type', HearReply.TEXT);

        this.state = {
            dropdownHearTypeOpen: false,
            valueHearTypeString: this.typeString(type),
            valueHearType: type,
            repliesData: repliesData,
            replyData: replyData,
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.receiveReplyData(nextProps);
    }

    receiveReplyData(nextProps) {

        let replyIndex = nextProps.replyIndex;
        let replyData = nextProps.repliesData[replyIndex];
        let type = getValueFromArray(replyData, 'type', HearReply.TEXT);

        this.setState({
            repliesData: nextProps.repliesData,
            replyData: replyData,
            valueHearType: type,
            valueHearTypeString: this.typeString(type),
        });
    }

    toggle() {
        this.setState({
            dropdownHearTypeOpen: !this.state.dropdownHearTypeOpen
        });
    }

    select(event) {
        const {hearReplies, replyIndex} = this.props;

        this.setState({
            dropdownHearTypeOpen: !this.state.dropdownHearTypeOpen,
            valueHearTypeString: this.typeString(event.target.value),
            valueHearType: event.target.value,
        });

        hearReplies.updateReply(replyIndex, "type", event.target.value);
    }

    deleteItem() {
        const {hearReplies, replyIndex} = this.props;

        hearReplies.deleteReply(replyIndex);
    }

    typeString(data) {
        let list = [];
        list[HearReply.FACEBOOK_GENERIC] = i18n.t("Facebook Generic");
        list[HearReply.FACEBOOK_BUTTON] = i18n.t("Facebook Button");
        list[HearReply.TEXT] = i18n.t("Text");
        list[HearReply.IMAGE] = i18n.t("Image");

        if (list[data]) return list[data];
        return data;
    }

    renderElementByType = () => {
        const {hearReplies, replyIndex} = this.props;

        let elements = [];

        switch (this.state.valueHearType) {
            case HearReply.FACEBOOK_GENERIC:
                elements.push(<HearFacebookGeneric
                    key={0}
                    fanpageId={this.props.fanpageId}
                    replyIndex={replyIndex}
                    hearReplies={hearReplies}
                    hearId={this.props.hearId}
                    replyData={this.state.replyData}
                />);
                break;

            case HearReply.FACEBOOK_BUTTON:
                elements.push(<HearFacebookButtons
                    key={0}
                    fanpageId={this.props.fanpageId}
                    hearReplies={hearReplies}
                    replyIndex={replyIndex}
                    buttonsHolder={hearReplies}
                    hearId={this.props.hearId}
                    replyData={this.state.replyData}
                    buttonsData={this.state.replyData.buttons}
                />);
                break;
            case HearReply.IMAGE:
                elements.push(<HearImage
                    key={0}
                    replyIndex={replyIndex}
                    hearReplies={hearReplies}
                    replyData={this.state.replyData}
                />);
                break;
            default:
                elements.push(<HearText
                    key={0}
                    replyIndex={replyIndex}
                    hearReplies={hearReplies}
                    replyData={this.state.replyData}
                />);
                break;
        }

        return elements;
    };

    render() {

        return (
            <div>
                <ButtonDropdown isOpen={this.state.dropdownHearTypeOpen} toggle={this.toggle}>
                    <DropdownToggle caret id={'reply_type_' + this.props.replyIndex}>
                        {this.state.valueHearTypeString}
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem header>{i18n.t("Hear Type")}</DropdownItem>
                        <DropdownItem
                            id={'change-hear-type-generic_' + this.props.replyIndex}
                            onClick={this.select}
                            value={HearReply.FACEBOOK_GENERIC}
                        >
                            {this.typeString(HearReply.FACEBOOK_GENERIC)}
                        </DropdownItem>
                        <DropdownItem
                            id={'change-hear-type-button_' + this.props.replyIndex}
                            onClick={this.select}
                            value={HearReply.FACEBOOK_BUTTON}
                        >
                            {this.typeString(HearReply.FACEBOOK_BUTTON)}
                        </DropdownItem>
                        <DropdownItem
                            id={'change-hear-type-text_' + this.props.replyIndex}
                            onClick={this.select}
                            value={HearReply.TEXT}
                        >
                            {this.typeString(HearReply.TEXT)}
                        </DropdownItem>
                        <DropdownItem
                            id={'change-hear-type-image_' + this.props.replyIndex}
                            onClick={this.select}
                            value={HearReply.IMAGE}
                        >
                            {this.typeString(HearReply.IMAGE)}
                        </DropdownItem>
                    </DropdownMenu>
                </ButtonDropdown>

                <Button close id={'delete_reply_' + this.props.replyIndex} className="text-danger" onClick={(e) => {
                    if (window.confirm(i18n.t("Delete this reply?"))) this.deleteItem(e)
                }}/>

                {this.renderElementByType()}
            </div>
        );
    }
}


export default HearReply;

